// String normalization used by the fuzzy matcher and alias lookup.
// Kept tiny + pure so it can be unit-tested or reused anywhere.

const LEADING_THE = /^the\s+/i;
const WHITESPACE = /\s+/g;
// Unicode combining marks (the diacritics that NFD decomposition produces).
const COMBINING_MARKS = /[̀-ͯ]/g;
// Punctuation we want to flatten to a space so that "Guinea-Bissau" and
// "Guinea Bissau" normalize to the same string, and "St. Kitts" matches
// "St Kitts". Apostrophes (both ASCII and curly) are stripped entirely so
// "Cote d'Ivoire" and "Cote dIvoire" both collapse to "cote divoire" — the
// fuzzy matcher tolerates that better than introducing a phantom space.
const PUNCTUATION_TO_SPACE = /[.,\-]/g;
const PUNCTUATION_TO_REMOVE = /['’]/g;

export const normalizeName = (input: string): string =>
  input
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .toLowerCase()
    .replace(LEADING_THE, "")
    .replace(PUNCTUATION_TO_REMOVE, "")
    .replace(PUNCTUATION_TO_SPACE, " ")
    .replace(WHITESPACE, " ")
    .trim();
